<div class="main-painel">
    <div class="title-panel">
        Integração de Arquivo Sankhya
    </div>
    <mat-divider></mat-divider>
    <div class="info">
        Configuração preparada para Inserção de Arquivos no ERP Sankhya
    </div>
    <mat-divider></mat-divider>
    
    <mat-divider></mat-divider>


</div>